import { configureStore } from '@reduxjs/toolkit';
import customerReducer from './pages/customer/_slice';
import deviceReducer from './pages/device/install/_slice';
import deviceSettingsReducer from './pages/device/update_settings/_slice';
import loginReducer from './pages/login/_slice';
import devicesDeactivationReducer from './pages/device/deactivate/_slice';

const store = configureStore({
  reducer: {
    login: loginReducer,
    customer: customerReducer,
    device: deviceReducer,
    deviceSettings: deviceSettingsReducer,
    devicesDeactivation: devicesDeactivationReducer,
  },
  devTools: true,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
